export const contractsMenu = {
    name: 'Contracts',
    paths: [
        {
            label: 'Contracts',
            path: '/contracts'
        },
    ]
};
